var SOY_AJAX_DEBUG = false;
/***************************
 *
 * usage
 *
 *         <ul class="post-card__list row"
 data-soy="ajax"
 data-soy-ajax-function="edd_get_discount_product_reqs"
 data-soy-ajax-output="output_here"
 data-soy-ajax-data='<?php echo json_encode(["code_id" => $post_id]) ?>'>
 <?php partials('loader', ['show' => true, 'title'=>'キャンペーン対象商品を検索中です……']) ?>
 </ul>

 *
 ***************************/

(function ($) {
    $(function () {

            var $ajax_containers = $('[data-soy="ajax"]');

            for (var i = 0; i < $ajax_containers.length; i++) {
                flexible_ajax($ajax_containers.get(i));
            }

            var wow = new WOW(
                {
                    boxClass: 'soy-ajax-wow',      // animated element css class (default is wow)
                    animateClass: 'soy-ajax-animated', // animation css class (default is animated)
                    offset: 0,          // distance to the element when triggering the animation (default is 0)
                    mobile: true,       // trigger animations on mobile devices (default is true)
                    live: true,       // act on asynchronously loaded content (default is true)
                    callback: function (box) {
                        flexible_ajax(box);
                    },
                    scrollContainer: null // optional scroll container selector, otherwise use window
                }
            );
            wow.init();
        }
    );

    /************************************************
     * DOMに関数や引数を指定することで所定の関数を非同期で呼び出し、
     * 返り値を描画することができる、柔軟性を重視した非同期処理
     ************************************************/
    function flexible_ajax(_container) {

        var $container = $(_container);

        if (typeof $container.data('soy-ajax-function') === 'undefined') {
            return;
        }

        var function_name = $container.data('soy-ajax-function');

        var data = $container.data('soy-ajax-data');

        // 返り値を出力箇所を強制的に指定する
        if (!$container.data('soy-ajax-output')) {
            $container.attr('data-soy-ajax-output', randStr());
        }

        data['output'] = $container.data('soy-ajax-output');

        soy_ajax(function_name, data, "GET", 'JSON', function (results) {

            var $ouput_to = $('[data-soy-ajax-output="' + results.output + '"');

            var output_html = results.html;

            if (SOY_AJAX_DEBUG) {
                console.log(output_html, "output_html of flexible_ajax.");
            }

            $ouput_to.hide().html(output_html).fadeIn();
        });
    }
})(jQuery);

/*******************************************************************************
 * ◆ AJAXアクセス my_ajax("func_name",{'arg1':'get_current_user_profile'},
 * function(data) {});
 ******************************************************************************/
function soy_ajax(func_name, args, method, dataType, onSuccess, onError, url) {

    if (typeof args === 'undefined' || args === null) {
        args = {};
    }

    // head内で宣言されている値を追加
    /* global ajax_url */
    var _ajax_url = (typeof url === 'undefined') ? ajax_url : url;
    args.action = "do_ajax";

    /* global ajax_nonce */
    args._ajax_nonce = ajax_nonce;

    // サーバー側で実行される関数名
    args.fn = func_name;

    if (typeof dataType === 'undefined' || dataType === '') {
        dataType = "JSON";
    }

    if (typeof method === 'undefined' || method === '') {
        method = "POST";
    }
    var json = {
        type: method,
        url: _ajax_url,
        data: args,
        dataType: dataType,
        success: function (data) {

            if (SOY_AJAX_DEBUG) {
                console.log(data, "response of the ajax request.");
            }

            if (isset(data.alert)) {
                for (var idx in data.alert) {
                    var soy_alert = data.alert[idx];
                    if (is_object(soy_alert)) {
                        soy_ajax_callback(soy_alert);
                    }
                }
            }

            if (typeof onSuccess !== 'undefined' && onSuccess !== "" && onSuccess !== null) {
                onSuccess(data);
            }
        },
        error: function (errorThrown) {
            if (typeof onError === 'undefined' || onError === "" || onError === null) {
                console.error("ERRORです");
                console.log(errorThrown);
                console.log(errorThrown.readyState);
                console.log(errorThrown.status);
                console.log(errorThrown.statusText);
                console.log(errorThrown.responseText);
            } else {
                onError(errorThrown);
            }
        }
    };

    if (SOY_AJAX_DEBUG) {
        console.log(json, "arguments");
    }

    jQuery.ajax(json);
}

var soy_ajax_callback = function (soy_alert) {
    if (typeof show_alert_of === 'function') {
        show_alert_of(soy_alert.type, soy_alert.message, soy_alert.important);
    }
}

// USAGE

//(function ($) {
//    $(function () {
//        soy_ajax("test", null, function (result) {
//            console.log(result);
//        });
//    });
//})(jQuery);